import { Component } from '@angular/core';

@Component({
  selector: 'app-inventory-aging',
  standalone: false,
  
  templateUrl: './inventory-aging.component.html',
  styles: ``
})
export class InventoryAgingComponent {

}
